import React from "react";
import { FormattedAmount } from "../FormattedAmount.js";

type Props = {
  itemsCount: number;
  label: string;
  description: string;
  total: number;
};

/**
 * Renders field heading to a VAT report field.
 */
export const FieldHeading = ({ itemsCount, label, description, total }: Props) => {
  return (
    <tr>
      <th colSpan={1} rowSpan={1 + itemsCount} className="vertical-top">
        {label}
      </th>
      <td colSpan={10}>{description}</td>
      <td colSpan={1} className="text-right">
        <strong>
          <FormattedAmount cents={total} />
        </strong>
      </td>
    </tr>
  );
};
